import { get } from 'lodash';

export default {
  requiresSupervision(policy) {
    const osRestrictions = get(policy, 'template.osRestrictions', []);
    return (osRestrictions.some(restriction => get(restriction, 'appleRestrictions.requiresSupervision', false)));
  },
};
